import { useState, useEffect } from 'react';
import { message } from 'antd';
import * as airwayBillService from '../../services/airwayBillService';
import * as portService from '../../services/portService';
import * as userService from '../../services/userService';

export const useAirwayBillData = (searchParams = {}) => {
  const [airwayBills, setAirwayBills] = useState([]);
  const [batches, setBatches] = useState([]);
  const [ports, setPorts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCustomers = async () => {
    try {
      const data = await airwayBillService.fetchCustomers({
        count_by_customer: true
      });
      setCustomers(data.map(customer => ({
        ...customer,
        airway_bill_count: customer.airway_bill_count || 0
      })));
    } catch (error) {
      console.error('Error fetching customers:', error);
      message.error('获取客户列表失败');
    }
  };

  const fetchAirwayBills = async () => {
    try {
      setLoading(true);
      const response = await airwayBillService.fetchAirwayBills(searchParams);
      setAirwayBills(response.results || []);
    } catch (error) {
      console.error('Error fetching airway bills:', error);
      message.error('获取空运单列表失败');
    } finally {
      setLoading(false);
    }
  };

  const fetchBatches = async () => {
    try {
      const data = await airwayBillService.fetchBatches();
      setBatches(data.results || []);
    } catch (error) {
      console.error('Error fetching batches:', error);
      message.error('获取批次列表失败');
    }
  };

  const fetchPorts = async () => {
    try {
      const data = await portService.fetchPorts();
      setPorts(data);
    } catch (error) {
      console.error('Error fetching ports:', error);
      message.error('获取口岸列表失败');
    }
  };


  useEffect(() => {
    fetchAirwayBills();
  }, [searchParams]);

  useEffect(() => {
    fetchBatches();
    fetchPorts();
    fetchCustomers();
  }, []);

  return {
    airwayBills,
    batches,
    ports,
    customers,
    loading,
    refetchAirwayBills: () => {
      fetchAirwayBills();
      fetchCustomers(); // Refresh customer counts when bills change
    }
  };
};
